import {
  Button,
  Spinner,
  SpinnerProps,
  type ButtonProps,
} from "flowbite-react";
import { cn } from "@/shared/utils/style.util";

type ButtonWithLoaderProps = React.PropsWithChildren<
  {
    isLoading?: boolean
    spinnerColor?: SpinnerProps["color"]
  }
  & ButtonProps
>;

export const ButtonWithLoader = ({
  isLoading = false,
  spinnerColor = "info",
  className,
  children,
  ...props
}: ButtonWithLoaderProps) => (
  <Button
    className={cn("flex items-center justify-center", className)}
    {...props}
  >
    {isLoading && (
      <Spinner
        size="md"
        className="me-3"
        color={spinnerColor}
        light={!props.outline}
      />
    )}
    {children}
  </Button>
);
